<template>
    <div style="width: 100%">
        <div class="flex" style="width: 100%">
            <div style="width: 100%">
                <AcclaroElasticSearchInput
                    @handleResults="parseResults"
                    @setNoResults="clearResults"
                    :page="this.paginationDetails.current"
                    :per-page="this.paginationDetails.offset"
                    :range-start="this.timeAgo.value"
                    :selected-account="this.selectedAccount"
                    ref="searchHandler"
                />
            </div>
            <div class="date-range-container">
                <acclaro-account-selector
                    @handleSelection="handleAccountSelected"
                />
            </div>
            <div class="date-range-container">
                <v-select
                    :clearable="false"
                    :options="dateOptions"
                    v-model="timeAgo"
                    label="label"
                    @input="dateSelected">
                    <template #open-indicator="{ attributes }">
                        <span v-bind="attributes"><chevron-down-icon :size="24" /></span>
                    </template>
                </v-select>
            </div>
        </div>
        <div>
            <span class="subtitle-text"> This is an initial version of global site search for our PM users, powered by Elastic Search. Please email <a href="mailto:myacclarosupport@acclaro.com">myacclarosupport@acclaro.com</a> with your feedback on the accuracy and usefulness of search results. </span>
        </div>
        <div v-if="this.recentSearches" style="display: flex; justify-content: flex-end;">
            <a v-on:click="viewRecent = !viewRecent">
                <span v-if="!this.viewRecent">Show </span>
                <span v-else>Hide </span>Recent Searches
            </a>
        </div>
        <div>
            <transition name="fade">
                <div v-if="this.viewRecent">
                    <ul>
                        <li @key="k" v-for="k in recentSearches">
                            <a @click.prevent="setSearchTermFromRecentSearch(k)">{{ k }}</a>
                        </li>
                    </ul>
                </div>
            </transition>
        </div>
        <div class="gridview-container" style="min-height: 750px">
            <div v-if="this.results.length">
                <div class="flex" style="justify-content: flex-end">
                    <span>Found {{ this.paginationDetails.total }} Result(s)</span>
                </div>
                <div>
                    <div>
                        <div v-if="this.results.length">
                            <div v-bind:key="order._id" v-for="order in this.results">
                                <admin-order-search-result :order="order"/>
                                <hr/>
                            </div>
                        </div>

                        <div>
                            <acclaro-pagination-light
                                v-if="this.results.length"
                                :show-previous-page="handlePrevious"
                                :show-next-page="handleNext"
                                :pagination-details="paginationDetails"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div v-else style="padding: 10px">
                <span v-if="initialLoad"><h4>Search results will appear here</h4></span>
                <span v-else>
                    <div>
                        <h4>No matches found</h4>
                        <p>Please adjust your search parameters and filters to try another search</p>
                    </div>
                </span>
                <hr />
                <div>
                    <div>The following are fields are supported for search:</div>
                    <ul>
                        <li>Order ID</li>
                        <li>Plunet ID</li>
                        <li>Order Name</li>
                        <li>Order Source File Names</li>
                        <li>Order Reference File Names</li>
                        <li>Order Target File Names</li>
                        <li>Order Comments</li>
                    </ul>
                    <span class="subtitle-text"> To suggest more fields to search by, please email <a href="mailto:myacclarosupport@acclaro.com">myacclarosupport@acclaro.com</a>. </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

/**
 * Wraps around AcclaroElasticSearchInput and provides
 * results in a list.
 */

import AcclaroPaginationLight from "../../../AcclaroPagination/AcclaroPaginationLight";
import AcclaroElasticSearchInput from "../../AcclaroElasticSearchInput";
import AcclaroAccountSelector from "../../../Micro-Components/Acclaro-Account-Selector/Acclaro-Account-Selector";
import AdminOrderSearchResult from "./AdminOrderSearchResult";
import moment from "moment";
import { ChevronDownIcon } from '../../../icons';
import axios from "axios";


export default {
    name: "AdminOrderSearchResultView",
    components: {
        AcclaroElasticSearchInput,
        AcclaroPaginationLight,
        AdminOrderSearchResult,
        AcclaroAccountSelector,
        ChevronDownIcon,
    },
    data: function () {
        return {
            results: [],
            total: 0,
            recentSearches: [],
            initialLoad: true,
            viewRecent: false,
            timeAgo: undefined,
            selectedAccount: undefined,
            dateOptions: [
                {
                    key: 'today',
                    label: 'Last 24 Hours',
                    value: moment().subtract(1, 'days').format('YYYY-MM-DD')
                },
                {
                    key: 'Month',
                    label: 'Last Month',
                    value: moment().subtract(7, 'days').format('YYYY-MM-DD')
                },
                {
                    key: 'lastThreeMonths',
                    label: 'Last 3 Months',
                    value: moment().subtract(3, 'months').format('YYYY-MM-DD')
                },
                {
                    key: 'pastYear',
                    label: 'Last Year',
                    value: moment().subtract(1, 'years').format('YYYY-MM-DD')
                }
            ],
            paginationDetails: {
                total: 0,
                current: 0,
                offset: 10
            },
        };
    },
    watch:{
        viewRecent(val){
            if(val){
                this.getSavedSearches();
            }
        }
    },
    mounted() {
        this.timeAgo = this.dateOptions?.find(d => d.key === 'lastThreeMonths');
        this.getSavedSearches();
    },
    computed: {
        optionsText() {
            return this.showAdvanced ? 'Hide details' : 'Show details'
        }
    },
    methods: {
        clearResults(){
            this.results = [];
        },
        getSavedSearches(){
            axios.get('/search/recent-searches')
                .then(
                    res => {
                        this.recentSearches =  res.data;
                    }
                ).catch((e) => {
                console.error(e);
            });
        },
        handleAccountSelected(account){
            this.selectedAccount = account
            this.$refs.searchHandler.fireSearch()
        },
        setAccount (state, account_id) {
            state.account_id = account_id;
            this.$refs.searchHandler.fireSearch()
        },
        parseResults(data) {
            this.initialLoad = false;
            this.paginationDetails.total = data?.total?.value;
            this.results = data.hits;
        },
        handleNext() {
            this.paginationDetails.current += this.paginationDetails.offset;
            this.$refs.searchHandler.fireSearch()
        },
        handlePrevious() {
            this.paginationDetails.current -= this.paginationDetails.offset;
            this.$refs.searchHandler.fireSearch()
        },
        setSearchTermFromRecentSearch(term){
            this.$refs.searchHandler.setSearchTerm(term);
            this.$refs.searchHandler.fireSearch();
        },
        dateSelected() {
            this.paginationDetails.current = 0;
            this.$refs.searchHandler.fireSearch()
        },
    },

};
</script>
<style scoped>

.subtitle-text {
    color: grey;
    font-size: 11px
}

.vs--searchable .vs__dropdown-toggle .vs--searchable .vs__dropdown-toggle
{
    height: 42px !important;
}

.date-range-container {
    width: 275px;
    margin-left: 10px;
}
</style>
